import React from 'react';
import PropTypes from 'prop-types';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

import { genIntervalName } from './MetricTrendAllIntervals';
import { MetricsForTrendPlotStacked, translateSeriesNames } from './StackedMetricTrend';
import { graphContainer } from './graphContainers';

function MetricTrendTable(props) {
  const { plotInterval, rollingPeriod, metric, metrics, data, widgetResizeTimestamp } = props;
  const scrollRef = React.useRef();
  const [height, setHeight] = React.useState();

  React.useEffect(() => {
    if (!scrollRef?.current) return;
    const element = scrollRef?.current?.getElement();
    setHeight(element?.clientHeight);
  }, [scrollRef.current, widgetResizeTimestamp]);

  const title = MetricsForTrendPlotStacked[metric]?.columnTitle || '';
  const gridHeader = [title].concat(Array.from({ length: rollingPeriod }, (_, i) => {
    return genIntervalName(plotInterval, i);
  }));

  const series = MetricsForTrendPlotStacked[metric]?.series || [];
  const gridData = series.filter(key => metrics.includes(key)).map(key => {
    const ret = [translateSeriesNames(metric, key)];
    Array.from({ length: rollingPeriod}).forEach((_, i) => {
      ret.push(data?.[plotInterval]?.[-i]?.[metric][key] || 0);
    });
    return ret;
  });

  const firstColumnWidth = metric === 'cpt_codes' ? 125 : metric === 'days_with_vitals' ? 200 : metric === 'cpt_combinations' ? 250 : 200;

  const content = (
    <OverlayScrollbarsComponent
      defer
      className="widget-scrollable no-stripes"
      options={{ scrollbars: { autoHide: 'leave', autoHideDelay: '100' } }}
      ref={scrollRef}
    >
      <div
        className="grid-widget"
        style={{ gridTemplateColumns: `${firstColumnWidth}px repeat(${rollingPeriod}, 1fr)`, gridTemplateRows: `auto repeat(${gridData.length}, 1fr)`, minHeight: height }}
      >
        {gridHeader.map((cell, j) => (
          <div
            className={`grid-header grid-cell ${j === 0 ? 'grid-cell-name' : j === rollingPeriod ? 'grid-cell-last' : ''}`}
            key={`header-${j}`}
          >
            {cell}
          </div>
        ))}

        {gridData.map((row, i) => row.map((cell, j) => (
          <div
            className={`grid-cell ${j === 0 ? 'grid-cell-name' : j === rollingPeriod ? 'grid-cell-last' : ''} ${i % 2 === 0 ? 'grid-cell-even' : 'grid-cell-odd'} ${i === gridData.length - 1 ? 'grid-cell-bottom' : ''}`}
            key={`${i}-${j}`}
          >
            {cell}
          </div>
        )))}
      </div>
    </OverlayScrollbarsComponent>
  );

  return graphContainer(content, MetricsForTrendPlotStacked[metric]?.label);
}

MetricTrendTable.propTypes = {
  plotInterval: PropTypes.string.isRequired,
  rollingPeriod: PropTypes.number.isRequired,
  metric: PropTypes.string.isRequired,
  metrics: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  widgetResizeTimestamp: PropTypes.any,
};

export default MetricTrendTable;
